// src/MyStory.js
import React from "react";
import { Link } from "react-router-dom";
import DailySeed from "./DailySeed";
function MyStory({
  form = { name: "", email: "", website: "" },
  loading = false,
  error = "",
  handleChange = () => {},
  handleSubmit = (event) => event.preventDefault(),
}) {
  const pageStyle = {
    minHeight: "100vh",
    background: "#f6f7f9",
    padding: "30px",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1000px",
    margin: "0 auto",
    background: "#ffffff",
    borderRadius: "30px",
    padding: "40px",
    boxShadow: "0 30px 80px rgba(0,0,0,0.08)",
  };

  const eyebrowStyle = {
    fontSize: "15px",
    fontWeight: "700",
    color: "#2e7d32",
    marginBottom: "12px",
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  };

  const titleStyle = {
    fontSize: "56px",
    fontWeight: "800",
    lineHeight: "1.08",
    marginBottom: "18px",
    color: "#111827",
  };

  const introStyle = {
    fontSize: "22px",
    color: "#4b5563",
    lineHeight: "1.6",
    marginBottom: "28px",
    maxWidth: "760px",
  };

  const sectionStyle = {
    marginBottom: "34px",
  };

  const headingStyle = {
    fontSize: "28px",
    fontWeight: "700",
    color: "#111827",
    marginBottom: "14px",
  };

  const paragraphStyle = {
    fontSize: "18px",
    color: "#374151",
    lineHeight: "1.85",
    marginBottom: "16px",
  };

  const videoWrapStyle = {
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
    marginBottom: "34px",
  };

  const noteBoxStyle = {
    background: "#e8f5e9",
    padding: "18px 20px",
    borderRadius: "14px",
    borderLeft: "5px solid #2e7d32",
    marginTop: "10px",
  };

  const noteTextStyle = {
    margin: 0,
    fontSize: "17px",
    color: "#1f2937",
    lineHeight: "1.75",
    fontWeight: "500",
  };

  const listStyle = {
    paddingLeft: "22px",
    color: "#374151",
    fontSize: "18px",
    lineHeight: "1.9",
    marginTop: "0",
  };

  const linkStyle = {
    display: "inline-block",
    marginBottom: "24px",
    color: "#1b5e20",
    fontWeight: "700",
    textDecoration: "none",
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <Link to="/" style={linkStyle}>
          ← Back home
        </Link>

        <p style={eyebrowStyle}>My Story</p>

        <h1 style={titleStyle}>The heart behind Makana Impact.</h1>

        <p style={introStyle}>
          This page is where you get to know me a little more personally. Makana
          Impact is not about pretending I have it all figured out. It is about
          showing up honestly, growing through life, and sharing the journey as
          it unfolds.
        </p>

        <div style={videoWrapStyle}>
<iframe
  width="100%"
  height="520"
  src="https://www.youtube.com/embed/cl3mf-dkP6U"
  title="Makana Impact Story"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  allowFullScreen
  style={{
    border: "none",
    display: "block",
    background: "#000000",
  }}
/>
        </div>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>Why I started this</h2>

          <p style={paragraphStyle}>
            Makana Impact started from a simple place: I wanted to build
            something real. Something honest. Something that reflects growth,
            faith, family, wellness, and the lessons that come from everyday
            life.
          </p>

          <p style={paragraphStyle}>
            I know what it feels like to doubt yourself, restart, learn late,
            and still keep going. This space is my way of building in public and
            letting people see the real process instead of only the polished
            version.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>What Makana Impact means to me</h2>

          <p style={paragraphStyle}>
            To me, Makana Impact means sharing something meaningful. It means
            growing step by step, staying grounded, and being honest about where
            I am in the journey. Not hype. Not pressure. Just real life, real
            lessons, and real progress.
          </p>

          <div style={noteBoxStyle}>
            <p style={noteTextStyle}>
              My goal is to create a place where people can feel comfortable,
              get to know me, and follow along without pressure.
            </p>
          </div>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>What you can expect from me</h2>

          <ul style={listStyle}>
            <li>Mindset and personal growth</li>
            <li>Wellness and routines that help in real life</li>
            <li>Faith and family values</li>
            <li>Lessons I am learning through life and growth</li>
            <li>Honest updates from the journey</li>
          </ul>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>Where this is going</h2>

          <p style={paragraphStyle}>
            Over time, I will keep adding more videos, more updates, and more of
            what is genuinely helping me grow. This is still growing, and that
            is part of the point. You are not just seeing a finished brand. You
            are seeing a real journey in motion.
          </p>

          <p style={paragraphStyle}>
            If you are here, I appreciate that. Take your time, watch the video,
            and get comfortable. You are always welcome here.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={headingStyle}>A part of my journey</h2>

          <p style={paragraphStyle}>
            This is a video I created over a year ago, before my mom passed
            away. After losing her, I stepped away from creating for a while
            because my heart just was not in it.
          </p>

          <p style={paragraphStyle}>
            I am sharing this here because it is still part of my story. It
            represents a season before grief, before the pause, and now it also
            represents the journey of finding my way back.
          </p>

          <div style={videoWrapStyle}>
  <iframe
    width="100%"
    height="520"
    src="https://www.youtube.com/embed/9_d5tR5QI34"
    title="Makana Impact Story"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
    style={{
      border: "none",
      display: "block",
      background: "#000000",
    }}
  />
</div>

          <div style={noteBoxStyle}>
            <p style={noteTextStyle}>
              A personal video from before a season of grief, pause, and
              reflection — now part of the story behind my return.
            </p>
          </div>
        </section>
<DailySeed />
        <div
          style={{
            marginTop: "50px",
            maxWidth: "560px",
            marginLeft: "auto",
            marginRight: "auto",
            background: "#ffffff",
            padding: "30px",
            borderRadius: "20px",
            boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              marginBottom: "10px",
              color: "#111827",
            }}
          >
            Join the journey
          </h2>

          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#6b7280",
              lineHeight: "1.7",
              marginBottom: "20px",
            }}
          >
            If this resonates with you, stay connected as I share more of my
            story, what I am learning, and what is helping me grow step by step.
          </p>

          <form onSubmit={handleSubmit}>
            <input
              name="name"
              placeholder="Your name"
              value={form.name}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "14px",
                marginBottom: "10px",
                borderRadius: "10px",
                border: "1px solid #ddd",
                fontSize: "16px",
              }}
            />

            <input
              name="email"
              type="email"
              placeholder="Your email"
              value={form.email}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "14px",
                marginBottom: "12px",
                borderRadius: "10px",
                border: "1px solid #ddd",
                fontSize: "16px",
              }}
            />

            <input
              type="text"
              name="website"
              value={form.website}
              onChange={handleChange}
              style={{ display: "none" }}
              tabIndex="-1"
              autoComplete="off"
            />

            {error ? (
              <p
                style={{
                  color: "#b91c1c",
                  fontSize: "14px",
                  marginTop: "0",
                  marginBottom: "12px",
                  textAlign: "center",
                }}
              >
                {error}
              </p>
            ) : null}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "16px",
                background: "linear-gradient(135deg, #2e7d32, #43a047)",
                color: "#ffffff",
                border: "none",
                borderRadius: "12px",
                fontWeight: "600",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              {loading ? "Loading..." : "🌱 Join the journey"}
            </button>

            <p
              style={{
                fontSize: "12px",
                textAlign: "center",
                marginTop: "10px",
                color: "#6b7280",
                lineHeight: "1.6",
              }}
            >
              No spam. No pressure. Unsubscribe anytime.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MyStory;